import { setupNavUsageTrackers } from './NavUsageTrackers';
import { isJasmineRunning } from '../../utils/testEnv';
const initializeUsageTrackers = ({
  userEmail,
  navType
}) => {
  if (!isJasmineRunning()) {
    setupNavUsageTrackers(userEmail, navType);
  }
};
export default initializeUsageTrackers;